export const pageAnimation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0, transition: { duration: 0.6 } }
};

export const slideAnimation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0, transition: { duration: 0.6 } }
};

export const slideLeftToRightAnimation = {
    initial: { x: -200 },
    animate: {
        x: 0,
        transition: {
            type: 'tween',
            ease: 'linear',
            duration: 0.2
        }
    }
};

export const slideRightToLeftAnimation = {
    initial: { x: 200 },
    animate: {
        x: 0,
        transition: {
            type: 'tween',
            ease: 'linear',
            duration: 0.2
        }
    }
};

export const signupIllustrationAnimation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0, transition: { duration: 0.6 } }
};

export const tooltipAnimation = {
    initial: { y: 50 },
    animate: {
        y: 0,
        transition: {
            type: 'tween',
            ease: 'linear',
            duration: 0.2
        }
    }
};

export const modalAnimation = {
    initial: { y: 50 },
    animate: {
        y: 0,
        transition: {
            type: 'tween',
            ease: 'linear',
            duration: 0.2
        }
    }
};

export const drawerAnimation = {
    initial: { x: '100%' },
    animate: {
        x: 0,
        transition: {
            type: 'tween',
            ease: 'easeOut',
            duration: 0.25
        }
    }
};

export const dropdownProfileDesktopAnimation = {
    initial: { y: -25, opacity: 0 },
    animate: {
        y: 0,
        opacity: 1
    },
    exit: { y: -25, opacity: 0 },
    transition: {
        type: 'tween',
        ease: 'linear',
        duration: 0.1
    }
};

export const dropdownProfileResponsiveAnimation = {
    initial: { x: -200, opacity: 0 },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            type: 'tween',
            ease: 'linear',
            duration: 0.1
        }
    }
};

export const slideTopToBottomAnimation = {
    initial: { y: -100, opacity: 0 },
    animate: {
        y: 0,
        transition: {
            type: 'tween',
            ease: 'linear',
            duration: 0.1
        }
    }
};

export const slideBottomToTopAnimation = {
    initial: { y: 100, opacity: 0 },
    animate: {
        y: 0,
        transition: {
            type: 'tween',
            ease: 'linear',
            duration: 0.1
        }
    }
};
